/* teadsErrorBoundary.tsx */
import { clearPauseAd } from '@shared/store/slices/ads.slice';
import { store } from '@shared/store/store';
import React from 'react';

/**
 * TeadsErrorBoundary props
 */
interface TeadsErrorBoundaryProps {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

/**
 * TeadsErrorBoundary state
 */
interface TeadsErrorBoundaryState {
  hasError: boolean;
}

/**
 * TeadsErrorBoundary component
 */
class TeadsErrorBoundary extends React.Component<
  TeadsErrorBoundaryProps,
  TeadsErrorBoundaryState
> {
  constructor(props: TeadsErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): TeadsErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('[Teads] Handler crashed:', error);
    store.dispatch(clearPauseAd());
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default TeadsErrorBoundary;
